import dayjs from 'dayjs';
import { TNote } from '../../../types';
import { CARD_ROWS_SPAN } from '../config';
import { CellCoordinates, GridData } from '../types';

export const coordinatesEqual = (a: CellCoordinates, b: CellCoordinates) => {
  return a.row === b.row && a.column === b.column && a.group === b.group;
};

export const getDayIndex = (date: Date, daysTimestamps: number[]) => {
  return daysTimestamps.findIndex((dayTimestamp) => {
    const dayDate = dayjs.unix(dayTimestamp);
    const noteDueDate = dayjs(date);
    return dayDate.isSame(noteDueDate, 'day');
  });
};

export const getTimeSlotIndex = (date: Date, timeSlots: number[]) => {
  const dueDateDayjs = dayjs(date);
  const dueHour = dueDateDayjs.hour();
  const dueMinute = dueDateDayjs.minute();

  // Convert due time to minutes from 00:00
  const dueTimeInMinutes = dueHour * 60 + dueMinute;

  const firstTimeSlot = timeSlots[0];

  // If target time is before 8:00 (480 minutes), log error and return early
  if (firstTimeSlot && dueTimeInMinutes < firstTimeSlot) {
    console.error(
      `Unexpected time: Due date ${dueDateDayjs.format('HH:mm')} results in target time before ${
        firstTimeSlot / 60
      } hours`,
    );
    return -1;
  }

  // Find exact match first
  let exactIndex = timeSlots.findIndex((slot) => slot === dueTimeInMinutes);
  if (exactIndex !== -1) {
    return exactIndex;
  }

  // If no exact match, ceil to next 30-minute interval and then subtract 2 hours
  const ceiledTargetTime = Math.ceil(dueTimeInMinutes / 30) * 30;

  // Find the ceiled time in timeSlots
  exactIndex = timeSlots.findIndex((slot) => slot === ceiledTargetTime);
  if (exactIndex !== -1) {
    return exactIndex;
  }

  // If still no match, log error
  console.error(
    `Could not find timeSlot for due date ${dueDateDayjs.format(
      'HH:mm',
    )}, target time: ${Math.floor(ceiledTargetTime / 60)}:${(ceiledTargetTime % 60)
      .toString()
      .padStart(2, '0')}`,
  );
  return -1;
};

export const isCardIntersecting = (
  notes: TNote[],
  dropCoordinates: CellCoordinates,
  gridData: GridData,
) => {
  return notes.some((note) => {
    if (note.backlogEnabled) return false;

    const timeSlotIndex = getTimeSlotIndex(new Date(note.dueDate), gridData.timeSlots);
    const dayIndex = getDayIndex(new Date(note.dueDate), gridData.days);
    const assigneeIndex = gridData.assignees.findIndex((a) => a.id === note.assignee);

    const isRowInRange = Math.abs(timeSlotIndex - dropCoordinates.row) <= CARD_ROWS_SPAN - 1;
    const isColTaken = assigneeIndex === dropCoordinates.column;
    const isGroupTaken = dayIndex === dropCoordinates.group;

    return isRowInRange && isColTaken && isGroupTaken;
  });
};
